<template>
	<div class="loginbg">
		<div class="login_logo"></div>
		<div class="popup_center ">
		  <div class="box_size">
		  <div class="login_img"></div>
		    <div class="login">
		      <div class="user_tab"  style="margin-top: 50px;">
		        <ul>
		          <li class="active" style="width:100%"><a>找回密码</a></li>
		        </ul>
		      </div>
		      <div class="login_input">
		        <ul>
		          <li>
		            <input type="email" placeholder="请输入您注册的E-mail" v-model="ecode" ref="currentemail">
		          </li>
		        </ul>
		      </div>
		      <div class="login_bot">
		      	 <p><em>
		          <i>&nbsp;</i></em> <a @click="gotoLogin">返回登录</a></p>
		        <span><a @click="submit">提交</a></span> </div> 
		    </div>
		  </div>
		</div>
		<div class="bot_tip">
			<span> <a>联系我们</a> | <a>法律声明</a> | <a>下载中心</a> | <a>网站地图</a></span>  
			<em>©2017 青岛迪迪网络科技有限公司 All Rights Reserved.</em>
		</div>
	    <!--页面tab弹框组件开始-->				
		<main-modal ref="modal1" size="small" title="提示" >
			<p v-text="tipContent"></p>	
			<div slot="footer">
				<button class="btn btn-primary" @click="closetip">关闭</button>
			</div>
		</main-modal>
	</div>
</template>

<script>
    import MainModal from 'components/common/MainModal'
    import { OPERATE_EXCEPTION,SEND_SUCCESS,EMAIL_FAILE,EMAIL_EXCEPTION } from 'static/message'
    import {isEmail} from 'util/util'
	export default {
		name: 'GetPassword',
		components: {
			MainModal
		},
		data() {
			return {
				ecode:'',
				tipContent:''
			}
		},
		methods: {
			submit(){
				if(!this.ecode) {
					this.opentip(EMAIL_FAILE);
					this.$refs.currentemail.focus();
					return;
				}
				if (!isEmail(this.ecode)){
					this.opentip(EMAIL_EXCEPTION);
					this.$refs.currentemail.focus();
					return;
				}
				this.$http.post(process.env.API_ROOT + '/noauth/accounts/password?user='+this.ecode) 
	    		.then( res => {
					if(res.data.success){
						this.opentip(SEND_SUCCESS);
					} else {
						this.opentip(res.data.message);
					}
				}, res => {
					this.opentip(res.data.message)
				}).catch( res => {
					this.opentip(OPERATE_EXCEPTION)
				})
			},
			closetip(){
				this.$refs.modal1.close();	
			},
			opentip(message){
				this.tipContent=message;
				this.$refs.modal1.open();	
			},
			gotoLogin(){
				this.$router.push("login");
			},
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// GetPassword.vue?2473054d